import { render, staticRenderFns } from "./perfis.vue?vue&type=template&id=1cb05d84&"
import script from "./perfis.vue?vue&type=script&lang=js&"
export * from "./perfis.vue?vue&type=script&lang=js&"
import style0 from "./perfis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports